import type SelfServicePageAuthType from 'owa-service/lib/contract/SelfServicePageAuthType';
import type { BookingSelfServicePageAuthType } from 'owa-graph-schema';

const mapSelfServicePageAuthType = (
    authType: SelfServicePageAuthType | undefined
): BookingSelfServicePageAuthType => {
    switch (authType) {
        case 1:
        case 1:
            return 'Business';
        default:
            return 'Anonymous';
    }
};

export default mapSelfServicePageAuthType;
